module.exports = __webpack_public_path__ + "9ae911f4d4e4ea143007598f678a4af2.png";